export default {
      id: "oc-res-file-system-usage",
      viewBox: "0 0 1229 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-file-system",
      toString: function () {
        return this.url;
      }
    }